import { NgModule } from '@angular/core';
import { AvcCreditLineComponent } from './components/avc-credit-line/avc-credit-line.component';
import { CommonModule } from '@angular/common';
import { NgbCompatModule } from '@uxdf/direct-shared-lib';
import { DfModule, DfSelectModule } from '@design-factory/design-factory';
import { StoreModule } from '@ngrx/store';
import { reducer } from './redux/reducers/reducers-credit-line';
import { EffectsAvcCreditLine } from './redux/effects/effects-avc-credit-line';
import { EffectsModule } from '@ngrx/effects';
import { FormsModule } from '@angular/forms';
import { AvcCreditLineChartComponent } from './components/avc-credit-line-chart/avc-credit-line-chart.component';

@NgModule({
    declarations: [AvcCreditLineComponent, AvcCreditLineChartComponent],
    imports: [
        StoreModule.forFeature('avc_credit_line', reducer),
        EffectsModule.forFeature([EffectsAvcCreditLine]),
        CommonModule,
        NgbCompatModule,
        FormsModule,
        DfSelectModule,
        DfModule
    ],
    exports: [AvcCreditLineComponent, AvcCreditLineChartComponent]
})
export class AvcCreditLineModule {}